// API configuration
export const getApiUrl = () => {
  // Check for environment variable first
  const raw = import.meta.env.VITE_API_URL as string | undefined;
  if (raw && raw.length > 0) {
    // Normalize: strip trailing slashes and accidental '/api' suffix
    let base = raw.trim();
    base = base.replace(/\/$/, '');
    base = base.replace(/\/api$/i, '');
    return base;
  }

  // In production, use relative URL (same origin)
  if (import.meta.env.PROD) {
    return '';
  }

  // In development, use localhost
  return 'http://localhost:3001';
};

export const API_URL = getApiUrl();
